import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import levelGroupAxios from '../../../axios/levelGroup'
import reportAxios from '../../../axios/report'

export const fetchLevelGroupFilterAppraisal = filter => {
  return dispatch => {
    dispatch(fetchLevelGroupFilterAppraisalStart())
    levelGroupAxios
      .get('/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchLevelGroupFilterAppraisalSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchLevelGroupFilterAppraisalFailed(error?.response?.data?.message))
      })
  }
}

export const fetchLevelGroupFilterAppraisalStart = () => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_START
  }
}

export const fetchLevelGroupFilterAppraisalSuccess = data => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_SUCCESS,
    data
  }
}

export const fetchLevelGroupFilterAppraisalFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_LEVEL_GROUP_FILTER_APPRAISAL_FAILED,
    errorMessage
  }
}

export const reportBonusSalary = recordData => {
  return dispatch => {
    dispatch(reportBonusSalaryStart())

    reportAxios
      .post('/report_bonus_salary', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Bonus Salary Created',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportBonusSalarySuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportBonusSalaryFailed())
      })
  }
}

export const reportBonusSalaryStart = () => {
  return {
    type: actionTypes.REPORT_BONUS_SALARY_START
  }
}

export const reportBonusSalarySuccess = data => {
  return {
    type: actionTypes.REPORT_BONUS_SALARY_SUCCESS,
    data
  }
}

export const reportBonusSalaryFailed = () => {
  return {
    type: actionTypes.REPORT_BONUS_SALARY_FAILED
  }
}

export const clearReportBonusSalary = () => {
  return {
    type: actionTypes.CLEAR_REPORT_BONUS_SALARY
  }
}
